<script setup lang="ts">
import { GTMContentGroup } from '~/lib/models/gtm'

definePageMeta({
  alias: ['/mi-cuenta/mis-pedidos', '/mon-compte/mes-commandes', '/minha-conta/meus-pedidos'],
  middleware: ['auth'],
})

useHeadSafe({
  meta: [
    {
      name: 'robots',
      content: 'noindex, nofollow',
    },
  ],
})
const route = useRoute()
const layout = 'profile'
const headerTitle = getAsideTitle(route.path)

const { trackPageView } = useGTM()
const { navigateToHome, profileRoute } = useMcdRoutes()
useOnLogout(navigateToHome)

const onBack = async () => {
  await navigateTo(profileRoute())
}

onMounted(() => {
  trackPageView({
    cg: GTMContentGroup.primary.ECOMMERCE,
    cg2: GTMContentGroup.secondary.ORDERS,
  })
})
</script>

<template>
  <NuxtLayout :name="layout" :havesection="headerTitle">
    <ComeBackHeader :header-title="headerTitle" @back="onBack" />
    <OrderHistory />
  </NuxtLayout>
</template>
